import { ItemList } from "../orm";

class PurchasedTrolleyList extends ItemList {
  getEntityKey() {
    return "customer/purchased_trolley";
  }
}

export const purchasedTrolleyList = new PurchasedTrolleyList(
  "purchased_trolley_default",
);

class PurchasedTrolleyPhotographsList extends ItemList {
  getEntityKey() {
    return "customer/purchased_trolley/photographs";
  }

  getPhotos({purchased_trolley_id}) {
    return this.saveNewObject({
      purchased_trolley_id: purchased_trolley_id,
    })
  }
}

export const purchasedTrolleyPhotographsList = new PurchasedTrolleyPhotographsList(
  "purchased_trolley_photographs_default",
);
